import React from 'react';
import { observer } from "mobx-react";
import LanguagePicker from "./LanguagePicker"
import {AccessibilityPicker} from "./Accessibility"
import {getLastSide} from "../../stores/objects/I18n"

const ModeMenus = observer(({store, inputRef}) => {
    return (
        <p style={{margin: "0px", 
                   textAlign: getLastSide(store)}}>
            <AccessibilityPicker store={store} inputRef={inputRef}/>
            <LanguagePicker store={store}/>
        </p>
    ) 
    
});

export default ModeMenus;